import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // we init with resources
    resources: {
      en: {
        translations: {
          "Black Quality": "Black Quality",
          "Dashboards, widgets": "Dashboards, widgets",
          Applications: "Applications",
          "Ready To Use Apps": "Ready To Use Apps",
          "Forms & Table": "Forms & Table",
          "Ready To Use Forms & Tables": "Ready To Use Forms & Tables",
          Components: "Components",
          "UI Components & Elaments": "UI Components & Elements",
          Pages: "Pages",
          "All Neccesory Pages Added": "All Necessary Pages Added",
          Miscellaneous: "Miscellaneous",
          "Bonus Pages & Apps.": "Bonus Pages & Apps.",
          Dashboard: "Dashboard",
          Default: "Default",
          Ecommerce: "Ecommerce",
          Widgets: "Widgets",
          General: "General",
          Chart: "Chart",
          "Page Layout": "Page Layout",
          "Hide Nav Scroll": "Hide Nav Scroll",
          "Footer Light": "Footer Light",
          "Footer Dark": "Footer Dark",
          "Footer Fixed": "Footer Fixed",
          Project: "Project",
          "Project List": "Project List",
          "Create New": "Create New",
          "File Manager": "File Manager",
          Product: "Product",
          "Product Page": "Product Page",
          "Product List": "Product List",
          "Payment Details": "Payment Details",
          "Order History": "Order History",
          Invoice: "Invoice",
          Cart: "Cart",
          Wishlist: "Wishlist",
          Checkout: "Checkout",
          Pricing: "Pricing",
          Email: "Email",
          "Email App": "Email App",
          "Email Compose": "Email Compose",
          Chat: "Chat",
          "Chat App": "Chat App",
          "Video chat": "Video Chat",
          Users: "Users",
          "Users Profile": "Users Profile",
          "Users Edit": "Users Edit",
          "Users Cards": "Users Cards",
          Bookmarks: "Bookmarks",
          Contacts: "Contacts",
          Tasks: "Tasks",
          Calendar: "Calendar",
          "Social App": "Social App",
          "To-Do": "To-Do",
          "Search Result": "Search Result",
          "Form Controls": "Form Controls",
          "Form Validation": "Form Validation",
          "Base Inputs": "Base Inputs",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Input Groups",
          "Mega Options": "Mega Options",
          "Form Widgets": "Form Widgets",
          Datepicker: "Datepicker",
          "Touch Spin": "Touch Spin",
          Select2: "Select2",
          Switch: "Switch",
          Typeahead: "Typeahead",
          Clipboard: "Clipboard",
          "Form Layout": "Form Layout",
          "Form Wizard 1": "Form Wizard 1",
          "Form Wizard 2": "Form Wizard 2",
          "Two Factor": "Two Factor",
          "Bootstrap Tables": "Bootstrap Tables",
          "Basic Tables": "Basic Tables",
          "Table Components": "Table Components",
          "Data Tables": "Data Tables",
          "Basic Init": "Basic Init",
          "Advance Init": "Advance Init",
          API: "API",
          "Data Sources": "Data Sources",
          "Ui Kits": "UI Kits",
          "Ui Components & Elements": "UI Components & Elements",
          Typography: "Typography",
          Avatars: "Avatars",
          "Helper Classes": "Helper Classes",
          Grid: "Grid",
          "Tag & Pills": "Tag & Pills",
          Progress: "Progress",
          Modal: "Modal",
          Alert: "Alert",
          Popover: "Popover",
          Tooltip: "Tooltip",
          Dropdown: "Dropdown",
          Accordion: "Accordion",
          Tabs: "Tabs",
          Lists: "Lists",
          "Bonus UI": "Bonus UI",
          Scrollable: "Scrollable",
          "Tree View": "Tree View",
          Toast: "Toast",
          Rating: "Rating",
          Dropzone: "Dropzone",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carousel",
          Ribbons: "Ribbons",
          Pagination: "Pagination",
          Breadcrumb: "Breadcrumb",
          Tour: "Tour",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "Todo Firebase",
          "Range Slider": "Range Slider",
          "Image Cropper": "Image Cropper",
          "Basic Card": "Basic Card",
          "Creative Card": "Creative Card",
          Timeline: "Timeline",
          Icons: "Icons",
          "Flag Icon": "Flag Icon",
          "Fontawesome Icon": "Fontawesome Icon",
          "Ico Icon": "Ico Icon",
          "Themify Icon": "Themify Icon",
          "Feather Icon": "Feather Icon",
          "Weather Icon": "Weather Icon",
          Buttons: "Buttons",
          "Default Style": "Default Style",
          "Flat Style": "Flat Style",
          "Edge Style": "Edge Style",
          "Raised Style": "Raised Style",
          "Button Group": "Button Group",
          Charts: "Charts",
          "Apex Chart": "Apex Chart",
          "Google Chart": "Google Chart",
          "Chatjs Chart": "Chatjs Chart",
          Chartist: "Chartist",
          "Sample Page": "Sample Page",
          "Error Page": "Error Page",
          "Error 400": "Error Page 400",
          "Error 401": "Error Page 401",
          "Error 403": "Error Page 403",
          "Error 404": "Error Page 404",
          "Error 500": "Error Page 500",
          "Error 503": "Error Page 503",
          Authentication: "Authentication",
          "Login Simple": "Simple Login",
          "Login With Bg Image": "Login With Bg Image",
          "Login With Image Two": "Login With Image Two",
          "Login With Validation": "Login With Validation",
          "Login With Tooltip": "Login With Tooltip",
          "Login With Sweetalert": "Login With Sweetalert",
          "Register Simple": "Simple Register",
          "Register With Bg Image": "Register With Bg Image",
          "Register With Two Image": "Register With Two Image",
          "Unlock User": "Unlock User",
          "Register Wizard": "Register Wizard",
          "Forget Password": "Forget Password",
          "Reset Password": "Reset Password",
          Maintenance: "Maintenance",
          "Coming Soon": "Coming Soon",
          "Coming Simple": "Coming Simple",
          "Coming with Bg video": "Coming with Bg video",
          "Coming with Bg Image": "Coming with Bg Image",
          "Email templates": "Email templates",
          "Basic Email": "Basic Email",
          "Basic With Header": "Basic With Header",
          "Ecommerce Template": "Ecommerce Template",
          "Email Template 2": "Email Template 2",
          "Ecommerce Email": "Ecommerce Email",
          "Order Success": "Order Success",
          Gallery: "Gallery",
          "Gallery Grid": "Gallery Grid",
          "Gallery Grid Desc": "Gallery Grid Desc",
          "Masonry Gallery": "Masonry Gallery",
          "Masonry With Desc": "Masonry With Desc",
          "Hover Effects": "Hover Effects",
          Blog: "Blog",
          "Blog Details": "Blog Details",
          "Blog Single": "Blog Single",
          "Add Post": "Add Post",
          FAQ: "FAQ",
          "Job Search": "Job Search",
          "Cards View": "Cards View",
          "List View": "List View",
          "Job Detail": "Job Detail",
          Apply: "Apply",
          Learning: "Learning",
          "Learning List": "Learning List",
          "Detail Course": "Detail Course",
          Maps: "Maps",
          "Google Map": "Google Map",
          "Leaflet Map": "Leaflet Map",
          Editors: "Editors",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          Knowledgebase: "Knowledgebase",
          "Support Ticket": "Support Ticket",
        },
      },
      es: {
        translations: {
          "Black Quality": "Calidad Negra",
          "Dashboards, widgets": "Tableros, widgets",
          Applications: "Aplicaciones",
          "Ready To Use Apps": "Aplicaciones Listas para Usar",
          "Forms & Table": "Formularios y Tabla",
          "Ready To Use Forms & Tables": "Formularios y Tablas Listos para Usar",
          Components: "Componentes",
          "UI Components & Elaments": "Componentes y Elementos de IU",
          Pages: "Páginas",
          "All Neccesory Pages Added": "Todas las Páginas Necesarias Agregadas",
          Miscellaneous: "Misceláneo",
          "Bonus Pages & Apps.": "Páginas y Aplicaciones de Bonificación",
          Dashboard: "Tablero",
          Default: "Predeterminado",
          Ecommerce: "Comercio Electrónico",
          Widgets: "Widgets",
          General: "General",
          Chart: "Gráfico",
          "Page Layout": "Diseño de Página",
          "Hide Nav Scroll": "Ocultar Desplazamiento de Navegación",
          "Footer Light": "Pie de Página Claro",
          "Footer Dark": "Pie de Página Oscuro",
          "Footer Fixed": "Pie de Página Fijo",
          Project: "Proyecto",
          "Project List": "Lista de Proyectos",
          "Create New": "Crear Nuevo",
          "File Manager": "Gestor de Archivos",
          Product: "Producto",
          "Product Page": "Página de Producto",
          "Product List": "Lista de Productos",
          "Payment Details": "Detalles de Pago",
          "Order History": "Historial de Pedidos",
          Invoice: "Factura",
          Cart: "Carrito",
          Wishlist: "Lista de Deseos",
          Checkout: "Pagar",
          Pricing: "Precios",
          Email: "Correo Electrónico",
          "Email App": "Aplicación de Correo Electrónico",
          "Email Compose": "Redacción de Correo Electrónico",
          Chat: "Chat",
          "Chat App": "Aplicación de Chat",
          "Video chat": "Chat de Video",
          Users: "Usuarios",
          "Users Profile": "Perfil de Usuarios",
          "Users Edit": "Editar Usuarios",
          "Users Cards": "Tarjetas de Usuarios",
          Bookmarks: "Marcadores",
          Contacts: "Contactos",
          Tasks: "Tareas",
          Calendar: "Calendario",
          "Social App": "Aplicación Social",
          "To-Do": "Tareas Pendientes",
          "Search Result": "Resultado de Búsqueda",
          "Form Controls": "Controles de Formulario",
          "Form Validation": "Validación de Formulario",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Casilla de Verificación y Radio",
          "Input Groups": "Grupos de Entrada",
          "Mega Options": "Opciones Mega",
          "Form Widgets": "Widgets de Formulario",
          Datepicker: "Selector de Fechas",
          "Touch Spin": "Selector Numérico",
          Select2: "Select2",
          Switch: "Interruptor",
          Typeahead: "Sugerencias",
          Clipboard: "Portapapeles",
          "Form Layout": "Diseño de Formulario",
          "Form Wizard 1": "Asistente de Formulario 1",
          "Form Wizard 2": "Asistente de Formulario 2",
          "Two Factor": "Doble Factor",
          "Bootstrap Tables": "Tablas de Bootstrap",
          "Basic Tables": "Tablas Básicas",
          "Table Components": "Componentes de Tabla",
          "Data Tables": "Tablas de Datos",
          "Basic Init": "Inicialización Básica",
          "Advance Init": "Inicialización Avanzada",
          API: "API",
          "Data Sources": "Fuentes de Datos",
          "Ui Kits": "Kits de IU",
          "Ui Components & Elements": "Componentes y Elementos de IU",
          Typography: "Tipografía",
          Avatars: "Avatares",
          "Helper Classes": "Clases de Ayuda",
          Grid: "Cuadrícula",
          "Tag & Pills": "Etiquetas y Pastillas",
          Progress: "Progreso",
          Modal: "Modal",
          Alert: "Alerta",
          Popover: "Popover",
          Tooltip: "Tooltip",
          Dropdown: "Menú Desplegable",
          Accordion: "Acordeón",
          Tabs: "Pestañas",
          Lists: "Listas",
          "Bonus UI": "UI de Bonificación",
          Scrollable: "Desplazable",
          "Tree View": "Vista de Árbol",
          Toast: "Toast",
          Rating: "Calificación",
          Dropzone: "Dropzone",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrusel",
          Ribbons: "Cintas",
          Pagination: "Paginación",
          Breadcrumb: "Migas de Pan",
          Tour: "Tour",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "Tareas Firebase",
          "Range Slider": "Control de Rango",
          "Image Cropper": "Recortador de Imágenes",
          "Basic Card": "Tarjeta Básica",
          "Creative Card": "Tarjeta Creativa",
          Timeline: "Línea de Tiempo",
          Icons: "Iconos",
          "Flag Icon": "Icono de Bandera",
          "Fontawesome Icon": "Icono Fontawesome",
          "Ico Icon": "Icono Ico",
          "Themify Icon": "Icono Themify",
          "Feather Icon": "Icono Feather",
          "Weather Icon": "Icono de Clima",
          Buttons: "Botones",
          "Default Style": "Estilo Predeterminado",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo de Borde",
          "Raised Style": "Estilo Elevado",
          "Button Group": "Grupo de Botones",
          Charts: "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico Google",
          "Chatjs Chart": "Gráfico Chatjs",
          Chartist: "Chartist",
          "Sample Page": "Página de Ejemplo",
          "Error Page": "Página de Error",
          "Error 400": "Página de Error 400",
          "Error 401": "Página de Error 401",
          "Error 403": "Página de Error 403",
          "Error 404": "Página de Error 404",
          "Error 500": "Página de Error 500",
          "Error 503": "Página de Error 503",
          Authentication: "Autenticación",
          "Login Simple": "Inicio de Sesión Simple",
          "Login With Bg Image": "Inicio de Sesión con Imagen de Fondo",
          "Login With Image Two": "Inicio de Sesión con Dos Imágenes",
          "Login With Validation": "Inicio de Sesión con Validación",
          "Login With Tooltip": "Inicio de Sesión con Tooltip",
          "Login With Sweetalert": "Inicio de Sesión con Sweetalert",
          "Register Simple": "Registro Simple",
          "Register With Bg Image": "Registro con Imagen de Fondo",
          "Register With Two Image": "Registro con Dos Imágenes",
          "Unlock User": "Desbloquear Usuario",
          "Register Wizard": "Asistente de Registro",
          "Forget Password": "Olvidar Contraseña",
          "Reset Password": "Restablecer Contraseña",
          Maintenance: "Mantenimiento",
          "Coming Soon": "Próximamente",
          "Coming Simple": "Próximamente Simple",
          "Coming with Bg video": "Próximamente con Video de Fondo",
          "Coming with Bg Image": "Próximamente con Imagen de Fondo",
          "Email templates": "Plantillas de Correo Electrónico",
          "Basic Email": "Correo Electrónico Básico",
          "Basic With Header": "Básico con Encabezado",
          "Ecommerce Template": "Plantilla de Comercio Electrónico",
          "Email Template 2": "Plantilla de Correo Electrónico 2",
          "Ecommerce Email": "Correo Electrónico de Comercio Electrónico",
          "Order Success": "Pedido Exitoso",
          Gallery: "Galería",
          "Gallery Grid": "Cuadrícula de Galería",
          "Gallery Grid Desc": "Descripción de Cuadrícula de Galería",
          "Masonry Gallery": "Galería de Mampostería",
          "Masonry With Desc": "Mampostería con Descripción",
          "Hover Effects": "Efectos de Desplazamiento",
          Blog: "Blog",
          "Blog Details": "Detalles de Blog",
          "Blog Single": "Entrada de Blog Individual",
          "Add Post": "Agregar Publicación",
          FAQ: "Preguntas Frecuentes",
          "Job Search": "Búsqueda de Trabajo",
          "Cards View": "Vista de Tarjetas",
          "List View": "Vista de Lista",
          "Job Detail": "Detalles de Trabajo",
          Apply: "Aplicar",
          Learning: "Aprendizaje",
          "Learning List": "Lista de Aprendizaje",
          "Detail Course": "Curso Detallado",
          Maps: "Mapas",
          "Google Map": "Mapa de Google",
          "Leaflet Map": "Mapa de Leaflet",
          Editors: "Editores",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          Knowledgebase: "Base de Conocimiento",
          "Support Ticket": "Ticket de Soporte",
        },
      },
      fr: {
        translations: {
          "Black Quality": "Qualité Noire",
          "Dashboards, widgets": "Tableaux de bord, widgets",
          Applications: "Applications",
          "Ready To Use Apps": "Applications Prêtes à l'Emploi",
          "Forms & Table": "Formulaires et Table",
          "Ready To Use Forms & Tables": "Formulaires et Tables Prêts à l'Emploi",
          Components: "Composants",
          "UI Components & Elaments": "Composants et Éléments d'UI",
          Pages: "Pages",
          "All Neccesory Pages Added": "Toutes les Pages Nécessaires Ajoutées",
          Miscellaneous: "Divers",
          "Bonus Pages & Apps.": "Pages et Applications Bonus",
          Dashboard: "Tableau de Bord",
          Default: "Par Défaut",
          Ecommerce: "Commerce Électronique",
          Widgets: "Widgets",
          General: "Général",
          Chart: "Graphique",
          "Page Layout": "Disposition de la Page",
          "Hide Nav Scroll": "Masquer le Défilement de la Barre de Navigation",
          "Footer Light": "Pied de Page Clair",
          "Footer Dark": "Pied de Page Foncé",
          "Footer Fixed": "Pied de Page Fixe",
          Project: "Projet",
          "Project List": "Liste de Projets",
          "Create New": "Créer Nouveau",
          "File Manager": "Gestionnaire de Fichiers",
          Product: "Produit",
          "Product Page": "Page de Produit",
          "Product List": "Liste de Produits",
          "Payment Details": "Détails de Paiement",
          "Order History": "Historique des Commandes",
          Invoice: "Facture",
          Cart: "Panier",
          Wishlist: "Liste de Souhaits",
          Checkout: "Paiement",
          Pricing: "Tarification",
          Email: "E-mail",
          "Email App": "Application de Messagerie",
          "Email Compose": "Composer un E-mail",
          Chat: "Discussion",
          "Chat App": "Application de Discussion",
          "Video chat": "Discussion Vidéo",
          Users: "Utilisateurs",
          "Users Profile": "Profil des Utilisateurs",
          "Users Edit": "Modifier les Utilisateurs",
          "Users Cards": "Cartes des Utilisateurs",
          Bookmarks: "Signets",
          Contacts: "Contacts",
          Tasks: "Tâches",
          Calendar: "Calendrier",
          "Social App": "Application Sociale",
          "To-Do": "À Faire",
          "Search Result": "Résultat de Recherche",
          "Form Controls": "Contrôles de Formulaire",
          "Form Validation": "Validation de Formulaire",
          "Base Inputs": "Entrées de Base",
          "Checkbox & Radio": "Cases à Cocher et Boutons Radio",
          "Input Groups": "Groupes d'Entrée",
          "Mega Options": "Options Méga",
          "Form Widgets": "Widgets de Formulaire",
          Datepicker: "Sélecteur de Date",
          "Touch Spin": "Sélecteur Numérique",
          Select2: "Select2",
          Switch: "Interrupteur",
          Typeahead: "Suggestion de Saisie",
          Clipboard: "Presse-Papiers",
          "Form Layout": "Disposition de Formulaire",
          "Form Wizard 1": "Assistant de Formulaire 1",
          "Form Wizard 2": "Assistant de Formulaire 2",
          "Two Factor": "Double Facteur",
          "Bootstrap Tables": "Tables Bootstrap",
          "Basic Tables": "Tables Basiques",
          "Table Components": "Composants de Table",
          "Data Tables": "Tables de Données",
          "Basic Init": "Initialisation Basique",
          "Advance Init": "Initialisation Avancée",
          API: "API",
          "Data Sources": "Sources de Données",
          "Ui Kits": "Kits d'UI",
          "Ui Components & Elements": "Composants et Éléments d'UI",
          Typography: "Typographie",
          Avatars: "Avatars",
          "Helper Classes": "Classes d'Aide",
          Grid: "Grille",
          "Tag & Pills": "Balises et Pastilles",
          Progress: "Progression",
          Modal: "Fenêtre Modale",
          Alert: "Alerte",
          Popover: "Pop-over",
          Tooltip: "Info-Bulle",
          Dropdown: "Menu Déroulant",
          Accordion: "Accordéon",
          Tabs: "Onglets",
          Lists: "Listes",
          "Bonus UI": "UI Bonus",
          Scrollable: "Déroulable",
          "Tree View": "Vue Arborescente",
          Toast: "Toast",
          Rating: "Évaluation",
          Dropzone: "Zone de Dépôt",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrousel",
          Ribbons: "Rubans",
          Pagination: "Pagination",
          Breadcrumb: "Fil d'Ariane",
          Tour: "Visite Guidée",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "Tâches Firebase",
          "Range Slider": "Curseur de Plage",
          "Image Cropper": "Recadrage d'Image",
          "Basic Card": "Carte Basique",
          "Creative Card": "Carte Créative",
          Timeline: "Chronologie",
          Icons: "Icônes",
          "Flag Icon": "Icône de Drapeau",
          "Fontawesome Icon": "Icône Fontawesome",
          "Ico Icon": "Icône Ico",
          "Themify Icon": "Icône Themify",
          "Feather Icon": "Icône Feather",
          "Weather Icon": "Icône de Météo",
          Buttons: "Boutons",
          "Default Style": "Style par Défaut",
          "Flat Style": "Style Plat",
          "Edge Style": "Style de Bord",
          "Raised Style": "Style Élevé",
          "Button Group": "Groupe de Boutons",
          Charts: "Graphiques",
          "Apex Chart": "Graphique Apex",
          "Google Chart": "Graphique Google",
          "Chatjs Chart": "Graphique Chatjs",
          Chartist: "Chartist",
          "Sample Page": "Page d'Exemple",
          "Error Page": "Page d'Erreur",
          "Error 400": "Page d'Erreur 400",
          "Error 401": "Page d'Erreur 401",
          "Error 403": "Page d'Erreur 403",
          "Error 404": "Page d'Erreur 404",
          "Error 500": "Page d'Erreur 500",
          "Error 503": "Page d'Erreur 503",
          Authentication: "Authentification",
          "Login Simple": "Connexion Simple",
          "Login With Bg Image": "Connexion avec Image de Fond",
          "Login With Image Two": "Connexion avec Deux Images",
          "Login With Validation": "Connexion avec Validation",
          "Login With Tooltip": "Connexion avec Infobulle",
          "Login With Sweetalert": "Connexion avec SweetAlert",
          "Register Simple": "Inscription Simple",
          "Register With Bg Image": "Inscription avec Image de Fond",
          "Register With Two Image": "Inscription avec Deux Images",
          "Unlock User": "Déverrouiller l'Utilisateur",
          "Register Wizard": "Assistant d'Inscription",
          "Forget Password": "Mot de Passe Oublié",
          "Reset Password": "Réinitialiser le Mot de Passe",
          Maintenance: "Maintenance",
          "Coming Soon": "Prochainement",
          "Coming Simple": "Prochainement Simple",
          "Coming with Bg video": "Prochainement avec Vidéo de Fond",
          "Coming with Bg Image": "Prochainement avec Image de Fond",
          "Email templates": "Modèles d'E-mail",
          "Basic Email": "E-mail Basique",
          "Basic With Header": "Basique avec En-tête",
          "Ecommerce Template": "Modèle de Commerce Électronique",
          "Email Template 2": "Modèle d'E-mail 2",
          "Ecommerce Email": "E-mail de Commerce Électronique",
          "Order Success": "Commande Réussie",
          Gallery: "Galerie",
          "Gallery Grid": "Grille de Galerie",
          "Gallery Grid Desc": "Description de la Grille de Galerie",
          "Masonry Gallery": "Galerie en Maçonnerie",
          "Masonry With Desc": "Maçonnerie avec Description",
          "Hover Effects": "Effets de Survol",
          Blog: "Blog",
          "Blog Details": "Détails du Blog",
          "Blog Single": "Article Unique du Blog",
          "Add Post": "Ajouter un Article",
          FAQ: "FAQ",
          "Job Search": "Recherche d'Emploi",
          "Cards View": "Vue en Cartes",
          "List View": "Vue en Liste",
          "Job Detail": "Détail de l'Emploi",
          Apply: "Postuler",
          Learning: "Apprentissage",
          "Learning List": "Liste d'Apprentissage",
          "Detail Course": "Cours Détail",
          Maps: "Cartes",
          "Google Map": "Carte Google",
          "Leaflet Map": "Carte Leaflet",
          Editors: "Éditeurs",
          "CK Editor": "Éditeur CK",
          "MDE Editor": "Éditeur MDE",
          Knowledgebase: "Base de Connaissances",
          "Support Ticket": "Ticket de Support",
        },
      },
      pt: {
        translations: {
          "Black Quality": "Qualidade Preto",
          "Dashboards, widgets": "Painéis, widgets",
          Applications: "Aplicações",
          "Ready To Use Apps": "Aplicações Prontas a Usar",
          "Forms & Table": "Formulários e Tabela",
          "Ready To Use Forms & Tables": "Formulários e Tabelas Prontos a Usar",
          Components: "Componentes",
          "UI Components & Elaments": "Componentes e Elementos de UI",
          Pages: "Páginas",
          "All Neccesory Pages Added": "Todas as Páginas Necessárias Adicionadas",
          Miscellaneous: "Diversos",
          "Bonus Pages & Apps.": "Páginas e Aplicações Extra",
          Dashboard: "Painel de Controlo",
          Default: "Padrão",
          Ecommerce: "Comércio Eletrónico",
          Widgets: "Widgets",
          General: "Geral",
          Chart: "Gráfico",
          "Page Layout": "Layout da Página",
          "Hide Nav Scroll": "Esconder Rolagem de Navegação",
          "Footer Light": "Rodapé Claro",
          "Footer Dark": "Rodapé Escuro",
          "Footer Fixed": "Rodapé Fixo",
          Project: "Projeto",
          "Project List": "Lista de Projetos",
          "Create New": "Criar Novo",
          "File Manager": "Gestor de Ficheiros",
          Product: "Produto",
          "Product Page": "Página de Produto",
          "Product List": "Lista de Produtos",
          "Payment Details": "Detalhes de Pagamento",
          "Order History": "Histórico de Encomendas",
          Invoice: "Fatura",
          Cart: "Carrinho",
          Wishlist: "Lista de Desejos",
          Checkout: "Finalizar Compra",
          Pricing: "Preços",
          Email: "Email",
          "Email App": "Aplicação de Email",
          "Email Compose": "Compor Email",
          Chat: "Chat",
          "Chat App": "Aplicação de Chat",
          "Video chat": "Chat de Vídeo",
          Users: "Utilizadores",
          "Users Profile": "Perfil de Utilizador",
          "Users Edit": "Editar Utilizador",
          "Users Cards": "Cartões de Utilizador",
          Bookmarks: "Marcadores",
          Contacts: "Contactos",
          Tasks: "Tarefas",
          Calendar: "Calendário",
          "Social App": "Aplicação Social",
          "To-Do": "Lista de Tarefas",
          "Search Result": "Resultado da Pesquisa",
          "Form Controls": "Controlos de Formulário",
          "Form Validation": "Validação de Formulário",
          "Base Inputs": "Entradas Básicas",
          "Checkbox & Radio": "Caixa de Seleção e Rádio",
          "Input Groups": "Grupos de Entrada",
          "Mega Options": "Opções Avançadas",
          "Form Widgets": "Widgets de Formulário",
          Datepicker: "Seletor de Datas",
          "Touch Spin": "Seletor Numérico",
          Select2: "Select2",
          Switch: "Interruptor",
          Typeahead: "Sugestão de Preenchimento",
          Clipboard: "Área de Transferência",
          "Form Layout": "Layout de Formulário",
          "Form Wizard 1": "Assistente de Formulário 1",
          "Form Wizard 2": "Assistente de Formulário 2",
          "Two Factor": "Dois Fatores",
          "Bootstrap Tables": "Tabelas Bootstrap",
          "Basic Tables": "Tabelas Básicas",
          "Table Components": "Componentes de Tabela",
          "Data Tables": "Tabelas de Dados",
          "Basic Init": "Inicialização Básica",
          "Advance Init": "Inicialização Avançada",
          API: "API",
          "Data Sources": "Fontes de Dados",
          "Ui Kits": "Kits de UI",
          "Ui Components & Elements": "Componentes e Elementos de UI",
          Typography: "Tipografia",
          Avatars: "Avatares",
          "Helper Classes": "Classes de Apoio",
          Grid: "Grelha",
          "Tag & Pills": "Etiquetas e Pastilhas",
          Progress: "Progresso",
          Modal: "Modal",
          Alert: "Alerta",
          Popover: "Popover",
          Tooltip: "Dica de Ferramenta",
          Dropdown: "Menu de Suspensão",
          Accordion: "Acordeão",
          Tabs: "Separadores",
          Lists: "Listas",
          "Bonus UI": "UI Adicional",
          Scrollable: "Com Rolagem",
          "Tree View": "Visualização de Árvore",
          Toast: "Toast",
          Rating: "Classificação",
          Dropzone: "Área de Descarga",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carrossel",
          Ribbons: "Fitas",
          Pagination: "Paginação",
          Breadcrumb: "Navegação",
          Tour: "Tour",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "Tarefas no Firebase",
          "Range Slider": "Slider de Intervalo",
          "Image Cropper": "Cortador de Imagem",
          "Basic Card": "Cartão Básico",
          "Creative Card": "Cartão Criativo",
          Timeline: "Linha do Tempo",
          Icons: "Ícones",
          "Flag Icon": "Ícone de Bandeira",
          "Fontawesome Icon": "Ícone Fontawesome",
          "Ico Icon": "Ícone Ico",
          "Themify Icon": "Ícone Themify",
          "Feather Icon": "Ícone Feather",
          "Weather Icon": "Ícone de Tempo",
          Buttons: "Botões",
          "Default Style": "Estilo Padrão",
          "Flat Style": "Estilo Plano",
          "Edge Style": "Estilo de Borda",
          "Raised Style": "Estilo Elevado",
          "Button Group": "Grupo de Botões",
          Charts: "Gráficos",
          "Apex Chart": "Gráfico Apex",
          "Google Chart": "Gráfico Google",
          "Chatjs Chart": "Gráfico Chatjs",
          Chartist: "Chartist",
          "Sample Page": "Página de Exemplo",
          "Error Page": "Página de Erro",
          "Error 400": "Página de Erro 400",
          "Error 401": "Página de Erro 401",
          "Error 403": "Página de Erro 403",
          "Error 404": "Página de Erro 404",
          "Error 500": "Página de Erro 500",
          "Error 503": "Página de Erro 503",
          Authentication: "Autenticação",
          "Login Simple": "Login Simples",
          "Login With Bg Image": "Login com Imagem de Fundo",
          "Login With Image Two": "Login com Duas Imagens",
          "Login With Validation": "Login com Validação",
          "Login With Tooltip": "Login com Dica de Ferramenta",
          "Login With Sweetalert": "Login com SweetAlert",
          "Register Simple": "Registro Simples",
          "Register With Bg Image": "Registro com Imagem de Fundo",
          "Register With Two Image": "Registro com Duas Imagens",
          "Unlock User": "Desbloquear Utilizador",
          "Register Wizard": "Assistente de Registro",
          "Forget Password": "Esqueci a Senha",
          "Reset Password": "Redefinir Senha",
          Maintenance: "Manutenção",
          "Coming Soon": "Em Breve",
          "Coming Simple": "Em Breve Simples",
          "Coming with Bg video": "Em Breve com Vídeo de Fundo",
          "Coming with Bg Image": "Em Breve com Imagem de Fundo",
          "Email templates": "Modelos de E-mail",
          "Basic Email": "E-mail Básico",
          "Basic With Header": "Básico com Cabeçalho",
          "Ecommerce Template": "Modelo de Comércio Eletrónico",
          "Email Template 2": "Modelo de E-mail 2",
          "Ecommerce Email": "E-mail de Comércio Eletrónico",
          "Order Success": "Encomenda Bem-sucedida",
          Gallery: "Galeria",
          "Gallery Grid": "Grade de Galeria",
          "Gallery Grid Desc": "Descrição da Grade de Galeria",
          "Masonry Gallery": "Galeria de Alvenaria",
          "Masonry With Desc": "Alvenaria com Descrição",
          "Hover Effects": "Efeitos de Passeio",
          Blog: "Blog",
          "Blog Details": "Detalhes do Blog",
          "Blog Single": "Postagem Única do Blog",
          "Add Post": "Adicionar Postagem",
          FAQ: "Perguntas Frequentes",
          "Job Search": "Pesquisa de Emprego",
          "Cards View": "Visualização de Cartões",
          "List View": "Visualização de Lista",
          "Job Detail": "Detalhe do Emprego",
          Apply: "Aplicar",
          Learning: "Aprendizado",
          "Learning List": "Lista de Aprendizado",
          "Detail Course": "Curso Detalhado",
          Maps: "Mapas",
          "Google Map": "Mapa do Google",
          "Leaflet Map": "Mapa Leaflet",
          Editors: "Editores",
          "CK Editor": "Editor CK",
          "MDE Editor": "Editor MDE",
          Knowledgebase: "Base de Conhecimento",
          "Support Ticket": "Ticket de Suporte",
        },
      },
      cn: {
        translations: {
          "Black Quality": "黑色品质",
          "Dashboards, widgets": "仪表板、小部件",
          Applications: "应用程序",
          "Ready To Use Apps": "准备就绪的应用程序",
          "Forms & Table": "表单和表格",
          "Ready To Use Forms & Tables": "准备就绪的表单和表格",
          Components: "组件",
          "UI Components & Elaments": "UI组件和元素",
          Pages: "页面",
          "All Neccesory Pages Added": "已添加所有必要页面",
          Miscellaneous: "杂项",
          "Bouns Pages & Apps.": "奖励页面和应用程序",
          Dashboard: "仪表板",
          Default: "默认",
          Ecommerce: "电子商务",
          Widgets: "小部件",
          General: "常规",
          Chart: "图表",
          "Page Layout": "页面布局",
          "Hide Nav Scroll": "隐藏导航滚动",
          "Footer Light": "浅色页脚",
          "Footer Dark": "深色页脚",
          "Footer Fixed": "固定页脚",
          Project: "项目",
          "Project List": "项目列表",
          "Create New": "创建新项目",
          "File Manager": "文件管理器",
          Product: "产品",
          "Product Page": "产品页面",
          "Product List": "产品列表",
          "Payment Details": "付款详情",
          "Order History": "订单历史",
          Invoice: "发票",
          Cart: "购物车",
          Wishlist: "愿望清单",
          Checkout: "结账",
          Pricing: "定价",
          Email: "电子邮件",
          "Email App": "电子邮件应用程序",
          "Email Compose": "撰写电子邮件",
          Chat: "聊天",
          "Chat App": "聊天应用程序",
          "Video chat": "视频聊天",
          Users: "用户",
          "Users Profile": "用户配置文件",
          "Users Edit": "编辑用户",
          "Users Cards": "用户卡片",
          Bookmarks: "书签",
          Contacts: "联系方式",
          Tasks: "任务",
          Calendar: "日历",
          "Social App": "社交应用程序",
          "To-Do": "去做",
          "Search Result": "搜索结果",
          "Ready To Use Froms & Tables": "即用型表格和表格",
          "Form Controls": "表单控件",
          "Form Validation": "表单验证",
          "Base Inputs": "基本输入",
          "Checkbox & Radio": "复选框和单选按钮",
          "Input Groups": "输入组",
          "Mega Options": "超级选项",
          "Form Widgets": "表单小部件",
          Datepicker: "日期选择器",
          "Touch Spin": "触摸旋转",
          Select2: "Select2",
          Switch: "开关",
          Typeahead: "输入提示",
          Clipboard: "剪贴板",
          "Form Layout": "表格布局",
          "Form Wizard 1": "表单向导1",
          "Form Wizard 2": "表格向导2",
          "Two Factore": "两个因素",
          "Bootstrap Tables": "引导表",
          "Basic Tables": "基本表格",
          "Table Components": "表格组件",
          "Data Tables": "数据表格",
          "Basic Init ": "基本初始化",
          "Advance Init": "高级初始化",
          API: "应用程序编程接口",
          "Data Sources": "数据源",
          "Ui Kits": "用户界面套件",
          "Ui Components & Elements": "用户界面组件和元素",
          Typography: "排版",
          Avatars: "头像",
          "Helper Classes": "辅助类",
          Grid: "网格",
          "Tag & Pills": "标签和药片",
          Progress: "进度",
          Modal: "模态框",
          Alert: "警告",
          Popover: "弹出框",
          Tooltip: "工具提示",
          Dropdown: "下拉菜单",
          Accordion: "手风琴",
          Tabs: "标签页",
          Lists: "列表",
          "Bonus Ui": "奖励界面",
          Scrollable: "可滚动",
          "Tree View": "可滚动",
          Toast: "提示",
          Rating: "评分",
          Dropzone: "文件上传区域",
          SweetAlert2: "SweetAlert2",
          Carousel: "猫头鹰旋转木马",
          Ribbons: "带子",
          Pagination: "分页",
          Breadcrumb: "面包屑",
          Tour: "旅游",
          "SweetAlert 2": "甜蜜警报2",
          "Todo FireBase": "基于Firebase的待办事项",
          "Range Slider": "范围滑块",
          "Image Cropper": "图像裁剪工具",
          "Basic Card": "基本卡片",
          "Creative Card": "创意卡片",
          Timeline: "时间线",
          Icons: "图标",
          "Flag Icon": "国旗图标",
          "Fontawesome Icon": "令人惊叹的图标",
          "Ico Icon": "图标 (Ico)",
          "Themify Icon": "主题化图标",
          "Feather Icon": "羽毛图标",
          "Whether Icon": "天气图标",
          Buttons: "纽扣",
          "Default Style": "默认样式",
          "Flate Style": "扁平样式",
          "Edge Style": "边框样式",
          "Raised Style": "凸起样式",
          "Button Group": "按钮组",
          Charts: "图表",
          "Apex Chart": "顶点图表",
          "Google Chart": "谷歌图表",
          "Chatjs Chart": "Chatjs图表",
          Chartist: "Chartist",
          "Sample Page": "示例页面",
          "Error Page": "错误页面",
          "Error 400": "错误页面 400",
          "Error 401": "错误页面 401",
          "Error 403": "错误页面 403",
          "Error 404": "错误页面 404",
          "Error 500": "错误页面 500",
          "Error 503": "错误页面 503",
          Authentication: "身份验证",
          "Login Simple": "简单登录",
          "Login With Bg Image": "带背景图像的登录",
          "Login With Image Two": "使用图片二登录",
          "Login With Validation": "带验证的登录",
          "Login With Tooltip": "带工具提示的登录",
          "Login With Sweetalert": "使用 Sweetalert 登录",
          "Register Simple": "简单注册",
          "Register With Bg Image": "带背景图像的注册",
          "Register With Two Image": "带两个图像的注册",
          "Unlock User": "解锁用户",
          "Register Wizard": "注册向导",
          "Forget Password": "忘记密码",
          "Reset Password": "重置密码",
          Maintenance: "维护",
          "Coming Soon": "即将推出",
          "Coming Simple": "简单的即将推出",
          "Coming with Bg video": "带背景视频的即将推出",
          "Coming with Bg Image": "带背景图像的即将推出",
          "Email templates": "电子邮件模板",
          "Basic Email": "基本电子邮件",
          "Basic With Header": "带头部的基本",
          "Ecomerce Template": "电子商务模板",
          "Email Template 2": "电子邮件模板2",
          "Ecommerce Email": "电子商务电子邮件",
          "Order Success": "订单成功",
          Gallery: "画廊",
          "Gallery Grid": "画廊网格",
          "Gallery Grid Desc": "画廊网格描述",
          "Masonry Gallery": "砌体画廊",
          "Masonry With Desc": "带描述的砌体",
          "Hover Effects": "悬停效果",
          Blog: "博客",
          "Blog Details": "博客详细信息",
          "Blog Single": "单篇博客",
          "Add Post": "添加文章",
          FAQ: "常见问题",
          "Job Search": "职位搜索",
          "Cards View": "卡片视图",
          "List View": "列表视图",
          "Job Detail": "职位详情",
          Apply: "申请",
          Learning: "学习",
          "Learning List": "学习列表",
          "Detail Course": "详细课程",
          Maps: "地图",
          "Google Map": "谷歌地图",
          "Leaflet Map": "Leaflet地图",
          Editors: "编辑器",
          "CK Editor": "CK编辑器",
          "MDE Editor": "MDE编辑器",
          Knowledgebase: "知识库",
          "Support Ticket": "支持票",
        },
      },
      ae: {
        translations: {
          "Black Quality": "جودة سوداء",
          "Dashboards, widgets": "لوحات القيادة، ويدجت",
          Applications: "تطبيقات",
          "Ready To Use Apps": "تطبيقات جاهزة للاستخدام",
          "Forms & Table": "نماذج وجدول",
          "Ready To Use Forms & Tables": "نماذج وجداول جاهزة للاستخدام",
          Components: "مكونات",
          "UI Components & Elaments": "مكونات وعناصر واجهة المستخدم",
          Pages: "صفحات",
          "All Neccesory Pages Added": "تمت إضافة جميع الصفحات الضرورية",
          Miscellaneous: "متنوع",
          "Bonus Pages & Apps.": "صفحات إضافية وتطبيقات",
          Dashboard: "لوحة القيادة",
          Default: "افتراضي",
          Ecommerce: "التجارة الإلكترونية",
          Widgets: "ويدجت",
          General: "عام",
          Chart: "رسم بياني",
          "Page Layout": "تخطيط الصفحة",
          "Hide Nav Scroll": "إخفاء تمرير القائمة",
          "Footer Light": "تذييل فاتح",
          "Footer Dark": "تذييل داكن",
          "Footer Fixed": "تذييل ثابت",
          Project: "مشروع",
          "Project List": "قائمة المشروع",
          "Create New": "إنشاء جديد",
          "File Manager": "مدير الملفات",
          Product: "منتج",
          "Product Page": "صفحة المنتج",
          "Product List": "قائمة المنتجات",
          "Payment Details": "تفاصيل الدفع",
          "Order History": "تاريخ الطلب",
          Invoice: "فاتورة",
          Cart: "عربة التسوق",
          Wishlist: "قائمة الرغبات",
          Checkout: "الدفع",
          Pricing: "التسعير",
          Email: "البريد الإلكتروني",
          "Email App": "تطبيق البريد الإلكتروني",
          "Email Compose": "إنشاء بريد إلكتروني",
          Chat: "الدردشة",
          "Chat App": "تطبيق الدردشة",
          "Video chat": "دردشة فيديو",
          Users: "المستخدمين",
          "Users Profile": "ملفات المستخدمين",
          "Users Edit": "تعديل المستخدمين",
          "Users Cards": "بطاقات المستخدمين",
          Bookmarks: "الإشارات المرجعية",
          Contacts: "جهات الاتصال",
          Tasks: "المهام",
          Calendar: "التقويم",
          "Social App": "تطبيق التواصل الاجتماعي",
          "To-Do": "قائمة المهام",
          "Search Result": "نتائج البحث",
          "Form Controls": "عناصر النماذج",
          "Form Validation": "تحقق من النماذج",
          "Base Inputs": "مدخلات أساسية",
          "Checkbox & Radio": "خانة اختيار وزر الراديو",
          "Input Groups": "مجموعات الإدخال",
          "Mega Options": "خيارات ضخمة",
          "Form Widgets": "أدوات النموذج",
          Datepicker: "منتقي التواريخ",
          "Touch Spin": "شريط تمرير القيم",
          Select2: "اختيار2",
          Switch: "مفتاح التبديل",
          Typeahead: "مقترحات الإدخال",
          Clipboard: "الحافظة",
          "Form Layout": "تخطيط النموذج",
          "Form Wizard 1": "معالج النماذج 1",
          "Form Wizard 2": "معالج النماذج 2",
          "Two Factor": "عاملين",
          "Bootstrap Tables": "جداول البوتستراب",
          "Basic Tables": "جداول أساسية",
          "Table Components": "مكونات الجدول",
          "Data Tables": "جداول البيانات",
          "Basic Init": "بداية أساسية",
          "Advance Init": "بداية متقدمة",
          API: "واجهة برمجة التطبيقات",
          "Data Sources": "مصادر البيانات",
          "Ui Kits": "مجموعات واجهة المستخدم",
          "Ui Components & Elements": "مكونات وعناصر واجهة المستخدم",
          Typography: "الخط",
          Avatars: "الصور الرمزية",
          "Helper Classes": "فئات المساعدة",
          Grid: "الشبكة",
          "Tag & Pills": "وسوم وأقراص",
          Progress: "التقدم",
          Modal: "نافذة منبثقة",
          Alert: "تنبيه",
          Popover: "تلميح منبثق",
          Tooltip: "تلميح",
          Dropdown: "قائمة منسدلة",
          Accordion: "أكورديون",
          Tabs: "علامات التبويب",
          Lists: "قوائم",
          "Bonus Ui": "واجهة مكافأة",
          Scrollable: "قابل للتمرير",
          "Tree View": "عرض شجري",
          Toast: "رسالة منبثقة",
          Rating: "تقييم",
          Dropzone: "منطقة الإسقاط",
          SweetAlert2: "SweetAlert2",
          Carousel: "متجر البومة",
          Ribbons: "أشرطة",
          Pagination: "ترقيم الصفحات",
          Breadcrumb: "سلسلة العناوين",
          Tour: "جولة",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "مهام Firebase",
          "Range Slider": "شريط تمرير المدى",
          "Image Cropper": "أداة قص الصور",
          "Basic Card": "بطاقة أساسية",
          "Creative Card": "بطاقة إبداعية",
          Timeline: "الجدول الزمني",
          Icons: "الأيقونات",
          "Flag Icon": "أيقونة العلم",
          "Fontawesome Icon": "أيقونة فونت أوسوم",
          "Ico Icon": "أيقونة ICO",
          "Themify Icon": "أيقونة Themify",
          "Feather Icon": "أيقونة الريشة",
          "Weather Icon": "أيقونة الطقس",
          Buttons: "أزرار",
          "Default Style": "نمط افتراضي",
          "Flat Style": "نمط مسطح",
          "Edge Style": "نمط حافة",
          "Raised Style": "نمط مرتفع",
          "Button Group": "مجموعة أزرار",
          Charts: "الرسوم البيانية",
          "Apex Chart": "رسم بياني أبيكس",
          "Google Chart": "رسم بياني جوجل",
          "Chatjs Chart": "رسم بياني Chatjs",
          Chartist: "رسم بياني",
          "Sample Page": "صفحة عينة",
          "Error Page": "صفحة خطأ",
          "Error 400": "صفحة خطأ 400",
          "Error 401": "صفحة خطأ 401",
          "Error 403": "صفحة خطأ 403",
          "Error 404": "صفحة خطأ 404",
          "Error 500": "صفحة خطأ 500",
          "Error 503": "صفحة خطأ 503",
          Authentication: "مصادقة",
          "Login Simple": "تسجيل الدخول البسيط",
          "Login With Bg Image": "تسجيل الدخول مع صورة خلفية",
          "Login With Image Two": "تسجيل الدخول مع صورتين",
          "Login With Validation": "تسجيل الدخول مع التحقق",
          "Login With Tooltip": "تسجيل الدخول مع تلميح",
          "Login With Sweetalert": "تسجيل الدخول مع Sweetalert",
          "Register Simple": "تسجيل بسيط",
          "Register With Bg Image": "تسجيل مع صورة خلفية",
          "Register With Two Image": "تسجيل مع صورتين",
          "Unlock User": "فتح المستخدم",
          "Register Wizard": "معالج التسجيل",
          "Forget Password": "نسيت كلمة المرور",
          "Reset Password": "إعادة تعيين كلمة المرور",
          Maintenance: "صيانة",
          "Coming Soon": "قريبًا",
          "Coming Simple": "قريبًا بسيط",
          "Coming with Bg video": "قريبًا مع فيديو خلفية",
          "Coming with Bg Image": "قريبًا مع صورة خلفية",
          "Email templates": "قوالب البريد الإلكتروني",
          "Basic Email": "بريد إلكتروني أساسي",
          "Basic With Header": "أساسي مع رأس",
          "Ecommerce Template": "قالب التجارة الإلكترونية",
          "Email Template 2": "قالب البريد الإلكتروني 2",
          "Ecommerce Email": "بريد إلكتروني للتجارة الإلكترونية",
          "Order Success": "نجاح الطلب",
          Gallery: "معرض",
          "Gallery Grid": "شبكة المعرض",
          "Gallery Grid Desc": "وصف شبكة المعرض",
          "Masonry Gallery": "معرض البناء",
          "Masonry With Desc": "معرض البناء مع وصف",
          "Hover Effects": "تأثيرات التحويم",
          Blog: "مدونة",
          "Blog Details": "تفاصيل المدونة",
          "Blog Single": "مقال مفرد في المدونة",
          "Add Post": "إضافة مقال",
          FAQ: "الأسئلة الشائعة",
          "Job Search": "بحث عن وظيفة",
          "Cards View": "عرض البطاقات",
          "List View": "عرض القائمة",
          "Job Details": "تفاصيل الوظيفة",
          Apply: "تطبيق",
          Learning: "تعلم",
          "Learning List": "قائمة التعلم",
          "Detailed Course": "تفاصيل الدورة",
          Maps: "خرائط",
          "Google Map": "خريطة Google",
          "Leaflet Map": "خريطة Leaflet",
          Editors: "المحررات",
          "CK Editor": "محرر CK",
          "MDE Editor": "محرر MDE",
          Knowledgebase: "قاعدة المعرفة",
          "Support Ticket": "تذكرة الدعم",
          "Ready To Use Froms & Tables": "جاهزة للاستخدام - النماذج والجداول",
          "Bouns Pages & Apps": "صفحات وتطبيقات إضافية",
          "Two Factore": "العامل المزدوج",
        },
      },
      du: {
        translations: {
          "Black Quality": "Schwarze Qualität",
          "Dashboards, widgets": "Dashboards, Widgets",
          Applications: "Anwendungen",
          "Ready To Use Apps": "Fertig zum Verwenden Apps",
          "Forms & Table": "Formulare & Tabelle",
          "Ready To Use Forms & Tables": "Fertig zum Verwenden Formulare & Tabellen",
          Components: "Komponenten",
          "UI Components & Elaments": "UI Komponenten & Elemente",
          Pages: "Seiten",
          "All Neccesory Pages Added": "Alle notwendigen Seiten hinzugefügt",
          Miscellaneous: "Verschiedenes",
          "Bonus Pages & Apps.": "Bonusseiten & Apps.",
          Dashboard: "Dashboard",
          Default: "Standard",
          Ecommerce: "E-Commerce",
          Widgets: "Widgets",
          General: "Allgemein",
          Chart: "Diagramm",
          "Page Layout": "Seitenlayout",
          "Hide Nav Scroll": "Navigation beim Scrollen ausblenden",
          "Footer Light": "Fußzeile hell",
          "Footer Dark": "Fußzeile dunkel",
          "Footer Fixed": "Fixierte Fußzeile",
          Project: "Projekt",
          "Project List": "Projektliste",
          "Create New": "Neu erstellen",
          "File Manager": "Dateimanager",
          Product: "Produkt",
          "Product Page": "Produktseite",
          "Product List": "Produktliste",
          "Payment Details": "Zahlungsdetails",
          "Order History": "Bestellverlauf",
          Invoice: "Rechnung",
          Cart: "Warenkorb",
          Wishlist: "Wunschliste",
          Checkout: "Kasse",
          Pricing: "Preisgestaltung",
          Email: "E-Mail",
          "Email App": "E-Mail App",
          "Email Compose": "E-Mail Verfassen",
          Chat: "Chat",
          "Chat App": "Chat App",
          "Video chat": "Video-Chat",
          Users: "Benutzer",
          "Users Profile": "Benutzerprofil",
          "Users Edit": "Benutzer bearbeiten",
          "Users Cards": "Benutzerkarten",
          Bookmarks: "Lesezeichen",
          Contacts: "Kontakte",
          Tasks: "Aufgaben",
          Calendar: "Kalender",
          "Social App": "Soziale App",
          "To-Do": "To-Do",
          "Search Result": "Suchergebnis",
          "Form Controls": "Formularelemente",
          "Form Validation": "Formularvalidierung",
          "Base Inputs": "Basis-Eingaben",
          "Checkbox & Radio": "Checkbox & Radio",
          "Input Groups": "Eingabegruppen",
          "Mega Options": "Mega-Optionen",
          "Form Widgets": "Formular-Widgets",
          Datepicker: "Datumsauswahl",
          "Touch Spin": "Berührungsdrehfeld",
          Select2: "Auswahlfeld",
          Switch: "Schalter",
          Typeahead: "Vorschlagliste",
          Clipboard: "Zwischenablage",
          "Form Layout": "Formularlayout",
          "Form Wizard 1": "Formular-Assistent 1",
          "Form Wizard 2": "Formular-Assistent 2",
          "Two Factor": "Zwei-Faktor",
          "Bootstrap Tables": "Bootstrap Tabellen",
          "Basic Tables": "Einfache Tabellen",
          "Table Components": "Tabellenkomponenten",
          "Data Tables": "Daten-Tabellen",
          "Basic Init": "Grundlegende Initialisierung",
          "Advance Init": "Fortgeschrittene Initialisierung",
          API: "API",
          "Data Sources": "Datenquellen",
          "Ui Kits": "UI Kits",
          "Ui Components & Elements": "UI Komponenten & Elemente",
          Typography: "Typografie",
          Avatars: "Avatare",
          "Helper Classes": "Hilfsklassen",
          Grid: "Raster",
          "Tag & Pills": "Tag & Pillen",
          Progress: "Fortschritt",
          Modal: "Modales Fenster",
          Alert: "Benachrichtigung",
          Popover: "Popover",
          Tooltip: "Tooltip",
          Dropdown: "Dropdown",
          Accordion: "Akkordeon",
          Tabs: "Tabs",
          Lists: "Listen",
          "Bonus UI": "Bonus-UI",
          Scrollable: "Scrollbar",
          "Tree View": "Baumansicht",
          Toast: "Toast",
          Rating: "Bewertung",
          Dropzone: "Dropzone",
          SweetAlert2: "SweetAlert2",
          Carousel: "Carousel",
          Ribbons: "Bänder",
          Pagination: "Seitennummerierung",
          Breadcrumb: "Breadcrumb",
          Tour: "Tour",
          "SweetAlert 2": "SweetAlert 2",
          "Todo FireBase": "Todo Firebase",
          "Range Slider": "Bereichsregler",
          "Image Cropper": "Bild zuschneiden",
          "Basic Card": "Grundlegende Karte",
          "Creative Card": "Kreative Karte",
          Timeline: "Zeitleiste",
          Icons: "Symbole",
          "Flag Icon": "Flaggensymbol",
          "Fontawesome Icon": "Fontawesome-Symbol",
          "Ico Icon": "Ico-Symbol",
          "Themify Icon": "Themify-Symbol",
          "Feather Icon": "Feather-Symbol",
          "Weather Icon": "Wettersymbol",
          Buttons: "Schaltflächen",
          "Default Style": "Standardstil",
          "Flat Style": "Flacher Stil",
          "Edge Style": "Kantenstil",
          "Raised Style": "Erhöhter Stil",
          "Button Group": "Schaltflächengruppe",
          Charts: "Diagramme",
          "Apex Chart": "Apex Diagramm",
          "Google Chart": "Google Diagramm",
          "Chatjs Chart": "Chatjs Diagramm",
          Chartist: "Chartist",
          "Sample Page": "Beispielseite",
          "Error Page": "Fehlerseite",
          "Error 400": "Fehlerseite 400",
          "Error 401": "Fehlerseite 401",
          "Error 403": "Fehlerseite 403",
          "Error 404": "Fehlerseite 404",
          "Error 500": "Fehlerseite 500",
          "Error 503": "Fehlerseite 503",
          Authentication: "Authentifizierung",
          "Login Simple": "Einfache Anmeldung",
          "Login With Bg Image": "Anmeldung mit Hintergrundbild",
          "Login With Image Two": "Anmeldung mit zwei Bildern",
          "Login With Validation": "Anmeldung mit Validierung",
          "Login With Tooltip": "Anmeldung mit Tooltip",
          "Login With Sweetalert": "Anmeldung mit Sweetalert",
          "Register Simple": "Einfache Registrierung",
          "Register With Bg Image": "Registrierung mit Hintergrundbild",
          "Register With Two Image": "Registrierung mit zwei Bildern",
          "Unlock User": "Benutzer entsperren",
          "Register Wizard": "Registrierungsassistent",
          "Forget Password": "Passwort vergessen",
          "Reset Password": "Passwort zurücksetzen",
          Maintenance: "Wartung",
          "Coming Soon": "Demnächst",
          "Coming Simple": "Demnächst einfach",
          "Coming with Bg video": "Demnächst mit Hintergrundvideo",
          "Coming with Bg Image": "Demnächst mit Hintergrundbild",
          "Email templates": "E-Mail Vorlagen",
          "Basic Email": "Einfache E-Mail",
          "Basic With Header": "Einfache mit Kopfzeile",
          "Ecommerce Template": "E-Commerce Vorlage",
          "Email Template 2": "E-Mail Vorlage 2",
          "Ecommerce Email": "E-Commerce E-Mail",
          "Order Success": "Bestellung erfolgreich",
          Gallery: "Galerie",
          "Gallery Grid": "Galerie Raster",
          "Gallery Grid Desc": "Galerie Raster Beschreibung",
          "Masonry Gallery": "Mauerwerksgalerie",
          "Masonry With Desc": "Mauerwerksgalerie mit Beschreibung",
          "Hover Effects": "Hover-Effekte",
          Blog: "Blog",
          "Blog Details": "Blogdetails",
          "Blog Single": "Einzelner Blogbeitrag",
          "Add Post": "Beitrag hinzufügen",
          FAQ: "FAQ",
          "Job Search": "Jobsuche",
          "Cards View": "Kartenansicht",
          "List View": "Listenansicht",
          "Job Detail": "Jobdetails",
          Apply: "Bewerben",
          Learning: "Lernen",
          "Learning List": "Lernliste",
          "Detail Course": "Kursdetails",
          Maps: "Karten",
          "Google Map": "Google Karte",
          "Leaflet Map": "Leaflet Karte",
          Editors: "Editoren",
          "CK Editor": "CK Editor",
          "MDE Editor": "MDE Editor",
          Knowledgebase: "Wissensdatenbank",
          "Support Ticket": "Support-Ticket",
        },
      },
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
